module.exports = __webpack_public_path__ + "img/APA at IFC 1976.35ff68a5.png";